export default "__VITE_ASSET__Bnxj1oY8__"